export enum LatexAllergyOptions {
  YES = 'Sim',
  NO = 'Não',
  NOT_INFORMED = 'Não informado'
}

export const latexAllergyOptions = [
  {
    label: 'Sim',
    value: LatexAllergyOptions.YES,
    booleanValue: true
  },
  {
    label: 'Não',
    value: LatexAllergyOptions.NO,
    booleanValue: false
  },
  {
    label: 'Não informado',
    value: LatexAllergyOptions.NOT_INFORMED,
    booleanValue: null
  }
]
